import combineStyles from 'components/Templates/general/combineStyles';

import {
  wrapperStyles,
  containerStyles,
  columnsWrapperStyles,
  singleColumnStyles,
  singleColumnTabletStyles,
  backgroundCover
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  sectionWrapperStyles,
  sectionWrapperTabletStyles,
  sectionWrapperMobileStyles,
  wrapperWithMarginStyles,
  wrapperWithMarginTabletStyles,
  typoParagraph,
  typoHeader,
  typoHeaderMobile
} from 'components/Templates/styles/Red/commonObjectsStyles';

import buttonSecondary from 'components/Templates/styles/Red/buttons/buttonSecondary';

import buttonStyles from 'components/Templates/styles/Red/buttonStyles';

/* eslint-disable */
const thisStyle = {
  wrapper: {
    '0': {
      ...wrapperStyles,
      ...sectionWrapperStyles,
      'position': 'relative',
      'background-color': '{sectionBackgroundColor}',
      'min-height': '50rem',
      'display': 'block',
      'width': '100%'
    },
    '76_8' : {
      ...sectionWrapperTabletStyles
    },
    '37_5' : {
      ...sectionWrapperMobileStyles
    }
  },
  wrapperWithMargin: {
    '0': {
      ...wrapperWithMarginStyles
    },
    '76_8' : {
      ...wrapperWithMarginTabletStyles
    }
  },
  containerImage: {
    '0': {
      ...containerStyles,
      display: 'block'
    }
  },
  columnsWrapper: {
    '0': {
      ...columnsWrapperStyles,
    'margin-bottom': '2rem'
    }
  },
  columnDescription: {
    '0': {
      ...singleColumnStyles,
      'padding-right': '5rem'
    },
    '76_8': {
      ...singleColumnTabletStyles,
      'padding-right': '0'
    }
  },
  columnForm: {
    '0': {
      ...singleColumnStyles,
      ...backgroundCover,
      'min-height': '35rem',
    },
    '76_8': {
      ...singleColumnTabletStyles
    }
  },
  title: {
    '0': {
      ...typoHeader,

    },
    '76_8' : {
      ...typoHeaderMobile,
    }
  },
  thankYou: {
    '0': {
      'font-size': '3.6rem',
      'margin-top' : '3rem',
      'text-align': 'center',
      'padding-top': '2rem',
      ...typoHeaderMobile
    },
  },
  errorWrapper: {
    '0': {
      ...typoHeaderMobile,
      'font-size': '2.6rem',
      'margin-top' : '3rem',
      'margin-bottom': 0
    }
  },
  inputTile: {
    '0': {
      'color': '{textColor}',
      'font-size': '1.2rem',
      'input_border-bottom-width': '1px',
      'input_border-top-width': '1px',
      'input_border-left-width': '1px',
      'input_border-right-width': '1px',
      'input_border-top-style': 'solid',
      'input_border-bottom-style': 'solid',
      'input_border-left-style': 'solid',
      'input_border-right-style': 'solid',
      'input_border-top-color': '{inpuBorderColor}',
      'input_border-bottom-color': '{inpuBorderColor}',
      'input_border-left-color': '{inpuBorderColor}',
      'input_border-right-color': '{inpuBorderColor}',
      'input_color': '{textColor}',
      'placeholder_color': '{disabledTextColor}',
      'counter_color': 'rgb(104,102,119)',
    },
  },
  inputTileCheckbox: {
    '0': {
      'margin-top': 0,
      'margin-bottom': '1rem',
      'color': '{textColor}',

    },
  },
  description: {
    '0': {
      ...typoParagraph,
      'margin-bottom': '10rem'
    },
    '76_8': {
      'margin-bottom': '7rem'
    }
  },
  sendButton: {
    '0': {
      ...buttonSecondary.buttonSecondary['0'],
      'margin-top': '5rem',
      'display': 'block',
      'color': '{primaryColor}',
      'border-top-color': `{primaryColor}`,
      'border-bottom-color': `{primaryColor}`, 
      'border-left-color': `{primaryColor}`,
      'border-right-color': `{primaryColor}`,
    },
    '37_5': {
      ...buttonSecondary.buttonSecondary['37_5'],
      'margin-top': '2rem',
      'display': 'block'
    }
    
    
  }
};

thisStyle.sendButton['0']['margin-left'] = 'auto';


export default combineStyles(thisStyle, buttonStyles);
